module.exports = __webpack_public_path__ + "static/media/2 1 tattoo arm cat skeletal neo-traditional polished eerie.1280x1694.77adff77.webp";